"use strict";
// write your code here
var body = document.getElementsByTagName("body")[0];
var logo = document.getElementsByClassName("logo")[0];
var promise1 = new Promise(function(resolve, reject) {
    logo.addEventListener("click", function(e) {
        resolve();
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(errorShow);
    }, 3000);
});
function showMessage() {
    var successMessage = document.createElement("div");
    successMessage.className = "message";
    successMessage.innerText = "Promise was resolved!";
    body.appendChild(successMessage);
}
function errorShow() {
    var div = document.createElement("div");
    div.className = "message error-message";
    div.textContent = "Promise was rejected!";
    body.appendChild(div);
}
promise1.then(showMessage).catch(errorShow);
promise2.then(showMessage).catch(errorShow);

//# sourceMappingURL=index.d8cea3f8.js.map
